import { gql } from '@apollo/client';

export const UPDATE_LESSON_STATUS_MUTATION = gql`
  mutation UpdateLessonStatus($id: uuid!, $status: String!) {
    update_lessons_by_pk(pk_columns: { id: $id }, _set: { status: $status }) {
      id
    }
  }
`;
